import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import Button from "../modules/Button";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { resetTokens } from "./redux/actions";
import { addCandidateInfo } from "../Register/redux/actions";
import { api } from "../../Services";
import TransitionAlerts from "../modules/Alerts";
import Timer from "../modules/Timer";
import LoginPage from ".";
import { addTokenInfo } from "./redux/actions";
import { addAllIncomeInfo, resetIncome } from "../IncomeDetails/redux/actions";
import {
  addAllEduInfo,
  addEduInfo,
  resetEdu,
} from "../Education/redux/actions";
import {
  addAllPersonalInfo,
  addPersonalInfo,
  resetState,
} from "../PersonalInfo/redux/actions";
import { useNavigate } from "react-router-dom";

import sad from "../../Assets/svg/sad.svg";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import ErrorBoundary from "../modules/ERcomponent";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
function MobileSignin(props) {
  const navigate = useNavigate();

  const [valid, setValid] = useState(false);
  const [resData, setResData] = useState([]);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [Err, setErr] = useState("");
  const [screenType, setScreenType] = useState("");
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [info, setInfo] = useState({
    mobile: "",
    otp: "",
  });
  const [timeRemaining, setTimeRemaining] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [alert, setAlert] = useState(false);
  const [otpCount, setOtpCount] = useState(0);
  const [type, setType] = useState("number");
  const [dead, setDead] = useState({ msg: "", date: "" });

  const dispatch = useDispatch();
  //   const registeredData = useSelector((state) => state.register.registeredData);

  const editText = () => {
    return (
      <div className="edit-text">
        <span className="left-edit">
          We have sent an OTP to {type === "number" ? info?.mobile : info?.otp}
        </span>
        <span
          onClick={() => setType({ ...type, type: "number" })}
          className="pointer right-edit"
        >
          Edit
        </span>
      </div>
    );
  };

  const nextField = async () => {
    if (type === "dead") {
      setType("number");
    }
    if (type === "number") {
      let numbercheck = await verifyContent("number");
      setLoader(true);
      console.log("numbercheck", numbercheck);
      if (numbercheck) {
        console.log("numbercheck", numbercheck);
      }
      if (numbercheck?.status) {
        numbercheck = numbercheck.status;
      }
      if (numbercheck?.data?.metadata?.code == 200) {
        setAlertType({
          ...alertType,
          msg: numbercheck?.data?.metadata?.message,
        });
        // setAlert(true);
        console.log("in 200 mobile", numbercheck);
        setLoader(false);
        setType({ type: "otp" });
      } else {
        setAlertType({
          ...alertType,
          msg: numbercheck?.data?.metadata?.message,
        });
        // alert('Sorry! Something went wrong')
        setAlert(true);
      }
    } else {
      let otpCheck = await verifyContent("otp");
      console.log("otpCheck", otpCheck);

      if (otpCheck?.status) {
        otpCheck = otpCheck.status;
      }
      if (otpCheck?.data?.metadata?.code == "200") {
        setAlertType({
          ...alertType,
          msg: otpCheck?.data?.metadata?.message,
        });
        setAlert(true);
        console.log("in 200 otp", otpCheck);

        let url = GetBaseUrl(window.location.href);
        // window.location.replace(url + "/signup/email");
        navigate("/signup/email");
      } else {
        setAlertType({
          ...alertType,
          msg: otpCheck?.data?.metadata?.message,
        });
        setAlert(true);
      }
    }
    setTimeout(() => setAlert(false), 3000);
    // makeRegister();
  };

  const filterInput = (data) => {
    let isError = true;

    if (type === "otp") {
      data = data.replace(/\D/g, "");
      if (data?.length > 5) {
        data = data.slice(0, 6);
        isError = false;
      } else if (data?.length < 6) {
        isError = true;
      }
      return data;
      // if (type === "number") {
      //   otp = data;
      // } else {
      //   info1.eOtp = data;
      // }
    } else if (type === "number") {
      data = data.replace(/\D/g, "");
      if (data?.length > 9) {
        data = data.slice(0, 10);
        isError = false;
      } else if (data?.length < 10) {
        isError = true;
      }
      // info1.mobile = data;
      return data;
    }

    console.log("is error", isError);
    // setValid(!isError);
    // setInfo({ ...info1 });
    // return data;
  };
  const checkLogin = () => {
    if (tokenData.token) {
      console.log("islogged");
      let url = GetBaseUrl(window.location.href);
      if (tokenData?.isAlumni) {
        // window.location.replace(url + "/application/submitted-status");
        navigate("/application/alumni/connect");
      } else if (tokenData?.applicationStatus === "Registered") {
        // window.location.replace(url + "/application/status");

        navigate("/application/status");
      } else if (tokenData?.applicationStatus === "Awarded") {
        // navigate("/application/pre-awarded");
        getTAC(false, tokenData.token, tokenData.appId);
      } else {
        // window.location.replace(url + "/application/submitted-status");
        navigate("/application/submitted-status");
      }
      // } else {
      //   let url = GetBaseUrl(window.location.href);
      //   window.location.replace(url);
    }
  };
  const assignData = (data) => {
    console.log("type", type);
    type === "number"
      ? setInfo({ ...info, mobile: filterInput(data.replace(/\D/g, "")) })
      : setInfo({ ...info, otp: data.replace(/\D/g, "") });
  };
  const getTAC = async (type, token, id) => {
    try {
      const tacData = await api.getTAC(token, id);
      if (tacData?.data.tacAccepted) {
        if (type) {
          navigate("/application/alumni/connect");
        } else {
          navigate("/application/submitted-status");
        }
      } else {
        if (type) {
          navigate("/application/alumni");
        } else {
          navigate("/application/pre-awarded");
        }
      }
      console.log("tac data", tacData);
      // if (tokenData.token && tokenData.appId) {

      // }
      // return users;
    } catch (err) {
      console.log("err in tac", err);
    }
  };

  const sendOtp = async (data) => {
    try {
      const users = await api.loginMobileOTP(data);
      if (users?.statusCode == 200) {
        setResData([
          users.data.resourceData[0]?.linkData,
          users.data.resourceData[0]?.referenceNumber,
        ]);
      }
      return users;
    } catch (err) {
      if (err.data) {
        console.log("error assigned 14", err.data);
        setErr(err?.data);
        setTimeout(() => setErr(""), 5000);
      }
      console.log(err.data);
    }
  };
  const verifyContent = async (category) => {
    setLoader(true);
    setIsLoading(true);
    try {
      let users;
      if (category === "number") {
        users = await sendOtp(info?.mobile);
        console.log("generate otp result", users);
        if (users?.statusCode != 200) {
          if (users?.data) {
            console.log("error not assigned", users.data);
            // setErr(users.data);
          }
        }
        if (users?.error) {
          console.log("error assigned 1", users?.error);
          setErr(users?.error);
          setTimeout(() => setErr(""), 5000);
        }
        // setErr(users?.error);
      } else {
        users = await makeLogin();
        // if (users.statusCode != 200) {
        //   alert(users.data);
        // }
      }
      console.log("login result", users);
      //   let url = GetBaseUrl(window.location.href);
      if (users.statusCode == 500 || users?.statusCode != 200) {
        // setAlertType({
        //   msg: users.data,
        //   type: "otp",
        // });
        if (users?.data) {
          console.log("error assigned 2", users.data);
          setErr(users.data);
          setTimeout(() => setErr(""), 5000);
        }
        if (users?.error) {
          console.log("error assigned 3", users.error);

          setErr(users?.error);
          setTimeout(() => setErr(""), 5000);
        }
        alert(users.data);
        setAlert(true);
        if (Err) {
          // setTimeout(() => setErr(""), 5000);
        }
        // setTimeout(() => setAlert(false), 3000);
      } else {
        // setErr(users.data);
        if (users?.error) {
          console.log("error assigned 4", users.error);

          setErr(users?.error);
          setTimeout(() => setErr(""), 5000);
        }
        // if (Err) {
        //   setTimeout(() => setErr(""), 3000);
        // }
      }
      console.log("users", users);
      //   window.location.replace(url);
      setLoader(false);
      setIsLoading(false);

      return users;
    } catch (error) {
      if (error?.error) {
        console.log("error assigned 5", error.error);

        setErr(error?.error);
        setTimeout(() => setErr(""), 5000);
      }
      if (error?.data) {
        console.log("error assigned 6", error?.data);
        setErr(error?.data);
        setTimeout(() => setErr(""), 5000);
      }

      if (error.statusCode == 500) {
        setAlertType({
          msg: error.data,
          type: "otp",
        });
        if (error.data) {
          console.log("error assigned 7", error.data);
          setErr(error.data);
          setTimeout(() => setErr(""), 5000);
        }
        alert(error.data);
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      } else if (error.statusCode == "403") {
        // alert(error.message)
        setAlertType({
          msg: "Sorry! Something went wrong, Please connect with administrater",
          type: "otp",
        });

        if (error.data) {
          console.log("error assigned 8", error.data);
          setErr(error?.data);
          setTimeout(() => setErr(""), 5000);
        }
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      } else {
        setAlert(true);
        if (error?.data) {
          console.log("error assigned 9", error.data);
          setErr(error?.data);
          setTimeout(() => setErr(""), 5000);
        }
        if (error?.error) {
          console.log("error assigned 10", error.error);

          setErr(error?.error);
          setTimeout(() => setErr(""), 5000);
        }
        setTimeout(() => setAlert(false), 3000);
      }
      setLoader(false);
      setIsLoading(false);
      // if (Err) {
      //   setTimeout(() => setErr(""), 3000);
      // }
      // alert(error.data)
      return error;
      // Handle error scenario
    }
  };
  const resendText = () => {
    return (
      <div className="edit-text">
        <span
          className={`left-edit ${timeRemaining > 0 ? "disabled-text" : ""} `}
          onClick={() => setTimeRemaining(30)}
        >
          Resend OTP{" "}
        </span>
        {timeRemaining > 0 && (
          <span className="pointer right-edit">
            00:
            {
              <Timer
                limit={30}
                isTime={(e) => setTimeRemaining(e)}
                time={timeRemaining}
              />
            }
          </span>
        )}
      </div>
    );
  };

  const getSignup = () => {
    let url = window.location.href;
    if (type === "number") {
      // window.location.replace(url + "signup/source");
      navigate("signup/source");
    } else {
      verifyContent("number");
    }
  };
  const destructureData = (data) => {
    console.log("in des", data);
    dispatch(addTokenInfo(["totalLoginResponse", data]));
    dispatch(addTokenInfo(["showBank", data?.collegeBankDetailsUpdated]));
    dispatch(addTokenInfo(["showSpoc", data?.collegeSpocDetails]));

    // dispatch(addTokenInfo(["defaultDob", data.user.application.personalInfo?.dob?.split('-').length === 3 ? true:false]));

    dispatch(addTokenInfo(["token", data.token]));
    dispatch(addTokenInfo(["refreshToken", data.refreshToken]));
    dispatch(addTokenInfo(["userId", data.user.userId]));
    dispatch(addTokenInfo(["appId", data.user.application.id]));
    dispatch(addTokenInfo(["isAlumni", data?.user?.alumni]));
    dispatch(
      addTokenInfo(["personalId", data.user.application.personalInfo.id])
    );
    dispatch(addTokenInfo(["registrationData", data.user.registration]));
    dispatch(addTokenInfo(["applicationData", data.user.application]));
    dispatch(addTokenInfo(["salesForceUserId", data.user.salesForceUserId]));
    dispatch(
      addTokenInfo([
        "applicationStatus",
        data.user.application.applicationStatus,
      ])
    );
    dispatch(addEduInfo(["year", data.user.registration.year]));
    dispatch(addEduInfo(["degreeType", data.user.registration.degree]));
    dispatch(addEduInfo(["college", data.user.registration.college]));
    if (data.user.application.incomeInfo) {
      console.log("edu is null", data.user.application.incomeInfo);
      dispatch(addAllIncomeInfo(data.user.application.incomeInfo));
    }
    dispatch(addAllEduInfo(data.user.application.eduInfo));

    let personalInfo = data.user.application.personalInfo;
    personalInfo["BirthCertificate"] = ""
    dispatch(addAllPersonalInfo(personalInfo));
    dispatch(
      addPersonalInfo({ type: "mobile", value: data.user.registration.mobile?.trim() })
    );
    dispatch(
      addPersonalInfo({ type: "email", value: data.user.registration.email?.trim() })
    );
    dispatch(addPersonalInfo({ type: "company", value: data?.user?.company }));
    dispatch(addPersonalInfo({ type: "exp2", value: data?.user?.experience }));
    let disList = [];
    if (data?.user?.application?.personalInfo?.personDisability) {
      const disabilities = data.user.application.personalInfo.personDisability;
      // disList = disabilities.replace(/^\[|\]$/g, "").split(",");
      disList= disabilities.split(',')
      // .map(item => item.trim()) // Remove whitespace around elements
      .filter(item => item && item !== "[" && item !== "]" && item !== "");
      disList=disList?.map(item=>item.replace(/^\[|\]$/g, ""))
    }
    if (disList.length === 0 || disList.includes(null)) {
      disList = [];
    }
    dispatch(addPersonalInfo({ type: "disability", value: disList }));
    // dispatch(addPersonalInfo({ type: "disability", value: [] }));
    // dispatch(addPersonalInfo({ type: "orphan", value: "" }));
  };

  const getLoginData = async () => {
    const data = {
      mobileNo: info.mobile,
      otp: info.otp || "",
      uiLinkData: resData[0],
      uiReferenceNumber: resData[1],
    };

    try {
      const result = await api.login(data);
      return result;
    } catch (err) {
      setErr(err.data);
      if (err.error) {
        console.log("error assigned 11", err.data);

        setErr(err.error);
        setTimeout(() => setErr(""), 5000);
      }
      // if (Err) {
      //   setTimeout(() => setErr(""), 3000);
      // }
      alert(err.data);
    }
  };
  const makeLogin = async () => {
    setIsLoading(true);

    try {
      setIsLoading(true);
      const result = await getLoginData();
      console.log(result);
      if (result.statusCode == 200) {
        if (result.data.active) {
          destructureData(result.data);

          let url = GetBaseUrl(window.location.href);
          if (result?.data?.user?.alumni) {
            getTAC(true, result.data.token, result.data.user.application.id);
            // window.location.replace(url + "/application/submitted-status");
            // navigate("/application/alumni");
          } else if (
            result?.data?.user?.application?.applicationStatus === "Registered"
          ) {
            if (
              result?.data?.user?.application?.personalInfo?.address?.length ===
              1
            ) {
              // dispatch(startTimer())
              // window.location.replace(url + "/application");
              navigate("/application");
            } else {
              // window.location.replace(url + "/application/status");
              navigate("/application/status");
            }
          } else if (
            result?.data?.user?.application?.applicationStatus === "Awarded"
          ) {
            getTAC(false, result.data.token, result.data.user.application.id);
            // window.location.replace(url + "/application/submitted-status");
            // navigate("/application/pre-awarded");
          } else {
            // window.location.replace(url + "/application/submitted-status");
            navigate("/application/submitted-status");
          }
        } else {
          setType("dead");
          setDead({ date: result.data.deadline, msg: result.data.message });
        }
      } else {
        if (result.data) {
          console.log("error assigned 12", result.data);
          setErr(result.data);
          setTimeout(() => setErr(""), 5000);
        }

        // if (
        //   result?.statusCode == 500 &&
        //   result?.data?.includes("Incorrect otp")
        // ) {
        //   setErr(result.data);
        //   setOtpCount((prev) => prev + 1);
        // }
      }
      setIsLoading(false);
      return result;
    } catch (error) {
      if (error.data) {
        console.log("error assigned 13", error.data);

        setErr(error.data);
        setTimeout(() => setErr(""), 5000);
      }
      // setTimeout(() => setErr(""), 5000);
      // alert(error.data)
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getFormattedData = (datestr) => {
    const date = new Date(datestr);

    date.setDate(date.getDate() + 2);

    const options = { month: "long", day: "numeric", weekday: "long" };

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const formattedDate = formatter?.format(date);
    return formattedDate;
  };
  useEffect(() => {
    // dispatch(startTimer());
    if (tokenData.showToast) {
      setAlert(true);
      setAlertType({
        ...alertType,
        msg: "Congratulations! Your Account has been created successfully",
      });
      setTimeout(() => {
        dispatch(addTokenInfo(["showToast", false]));
        setAlert(false);
      }, 3000);
    }
    let url = window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "");
    if (url.split("/")[1] && props.setunknownUrl) {
      props.setunknownUrl(true);
    }
  }, []);
  useEffect(() => {
    dispatch(addCandidateInfo(["course", ""]));
    // dispatch(addCandidateInfo(["course", ""]));
    let url = window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "");
    if (!url.split("/")[1]) {
      checkLogin();
    }
  }, []);

  //   useEffect(() => {
  //     console.log("valid changed", valid);
  //   }, [registeredData?.info]);
  console.log("register error", Err);
  return (
    <LoginPage>
      <div className={`cred-section login-div ${type}`}>
        {type !== "dead" && <span className="title">Sign in</span>}
        {type === "dead" ? (
          <img className="sad" src={sad} alt="happy" />
        ) : (
          <span className="sub-title">
            {type === "otp"
              ? editText()
              : `You will receive an OTP on your Mobile`}
          </span>
        )}
        {type === "dead" ? (
          <div className="md-title">{dead.msg}</div>
        ) : (
          <div className="cred-fields">
            <Input
              onChange={(e) => assignData(e.replace(/\D/g, ""))}
              inputType={type === "number" && "mobile"}
              placeholder={
                type === "number" ? "Enter Mobile Number" : "Enter OTP"
              }
              // value={"2222"}
              value={type === "number" ? info?.mobile : info?.otp}
              // setValid={(e) => setValid(e)}
              // onChange={(e) => setVal(e)}
              type={"password"}
              id={"password"}
            />
            <ErrorBoundary>
              {Err && (
                <p className="set-sub-title" style={{ color: "red" }}>
                  {Err}
                </p>
              )}
            </ErrorBoundary>
          </div>
        )}
        {dead.date && (
          <span className="option-text">
            The deadline was {getFormattedData(dead.date)}
          </span>
        )}
        {alertType.msg && (
          <TransitionAlerts isAlert={alert} message={alertType.msg} />
        )}
        <div className="cred-btn">
          <Button
            disabled={
              type === "dead"
                ? false
                : type === "number"
                ? info?.mobile?.length < 10
                : info?.otp?.length < 6
            }
            value={
              type === "dead" ? (
                "Back to Home"
              ) : isLoading ? (
                <div className="loading-spinner">
                  {/* Add your loading spinner component or icon here */}
                  <i className="fas fa-spinner fa-spin"></i>
                </div>
              ) : (
                "Next"
              )
            }
            type={"contained"}
            onClickHandler={() => nextField()}
          />
          {type !== "dead" && (
            <Button
              onClickHandler={() => getSignup()}
              value={
                type === "number" ? "New user? Sign up here" : resendText()
              }
              type={"only-text"}
            />
          )}
        </div>
      </div>
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </LoginPage>
  );
}

export default MobileSignin;
